export const USER_LOGIN_CUSTOM_EVENT = "user_login";
